import factoryWithTypeCheckers from '../node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/factoryWithTypeCheckers.js';

var require$$1 = factoryWithTypeCheckers;

export { require$$1 as default };
//# sourceMappingURL=factoryWithTypeCheckers.js_commonjs-proxy.js.map
